export default function AboutHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#1a1a1a] overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20architectural%20texture%20stone%20concrete%20wall%20minimalist%20dark%20background%20commercial%20space%20design%20detail%20high%20contrast%20dramatic%20lighting&width=1920&height=700&seq=abouthero001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-px bg-[#b8956a]"></div>
            <span className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase">About Us</span>
          </div>
          <h1
            className="text-white font-bold leading-[1.25] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)' }}
          >
            關於心旅商研
          </h1>
          <p
            className="text-white/65 leading-[1.75] max-w-2xl"
            style={{ fontSize: '1.1875rem' }}
          >
            我們不只是一間商業空間設計公司，更是品牌商業空間策略夥伴。
            從策略規劃、空間設計到工程整合落地，心旅商研協助每一個商業品牌，
            打造真正具有競爭力的空間資產。
          </p>
        </div>
      </div>
    </section>
  );
}
